export default __webpack_public_path__ + "static/media/white-logo.43220139.png";